<form novalidate #propertyRentalAttributeSectionForm="ngForm">
    <div
        class="property-rental-attribute-section__pets-smokers-grid-container"
        *ngIf="draftLoaded$ | async"
    >
        <tg-select-container
            class="property-rental-attribute-section__pets-ok"
            label="Pets OK"
        >
            <select
                tgSelect
                name="pets"
                (change)="publish()"
                [(ngModel)]="draftData.propertyDescription.pets"
                [validation]="validation.propertyDescription.pets | toValidator"
            >
                <option *ngFor="let opt of metadata.pets" [ngValue]="opt.value">
                    {{ opt.display }}
                </option>
            </select>
        </tg-select-container>
        <tg-select-container
            class="property-rental-attribute-section__smokers-ok"
            label="Smokers OK"
        >
            <select
                tgSelect
                name="smokers"
                (change)="publish()"
                [(ngModel)]="draftData.propertyDescription.smokers"
                [validation]="
                    validation.propertyDescription.smokers | toValidator
                "
            >
                <option
                    *ngFor="let opt of metadata.smokers"
                    [ngValue]="opt.value"
                >
                    {{ opt.display }}
                </option>
            </select>
        </tg-select-container>
    </div>
    <tg-input-container
        class="property-rental-attribute-section__furnishings-and-whiteware"
        label="Furnishings & whiteware"
        showRemainingCharacters="false"
    >
        <textarea
            tgTextInput
            name="whiteware"
            rows="2"
            [validation]="
                validation.propertyDescription.whiteware | toValidator
            "
            placeholder="e.g. bed, washing machine, dryer, dishwasher"
            (blur)="publish()"
            [(ngModel)]="draftData.propertyDescription.whiteware"
        ></textarea>
    </tg-input-container>
    <div class="property-rental-attribute-section__amenities">
        <tg-input-container
            class="property-rental-attribute-section__amenities-input"
            label="Amenities in this area"
            showRemainingCharacters="false"
        >
            <textarea
                tgTextInput
                ngModel
                name="amenities"
                rows="3"
                [validation]="
                    validation.propertyDescription.amenities | toValidator
                "
                placeholder="What's nearby? Shops, parks, motorway access etc."
                (blur)="publish()"
                [(ngModel)]="draftData.propertyDescription.amenities"
            ></textarea>
        </tg-input-container>
        <p class="property-rental-attribute-section__amenities-text">
            Note: Nearby schools and zoning will automatically be included based
            on the property's address
        </p>
    </div>
    <tg-input-container
        class="property-rental-attribute-section__ideal-tenants"
        label="Your ideal tenants"
        showRemainingCharacters="false"
    >
        <textarea
            tgTextInput
            ngModel
            name="idealTenants"
            rows="2"
            [validation]="
                validation.propertyDescription.idealTenant | toValidator
            "
            placeholder="What are you looking for in a tenant?"
            (blur)="publish()"
            [(ngModel)]="draftData.propertyDescription.idealTenant"
        ></textarea>
    </tg-input-container>
    <tg-select-container
        class="property-rental-attribute-section__max-tenants"
        label="Maximum number of tenants"
    >
        <select
            tgSelect
            ngModel
            name="maxTenants"
            (change)="publish()"
            [(ngModel)]="draftData.propertyDescription.maxTenants"
            [validation]="
                validation.propertyDescription.maxTenants | toValidator
            "
        >
            <option
                *ngFor="let opt of metadata.maxTenants"
                [ngValue]="opt.value"
            >
                {{ opt.display }}
            </option>
        </select>
    </tg-select-container>
</form>
